import React from "react";
import styled, { css } from "styled-components";
import { ExhibitionProject } from "interfaces/front/business";
import SeeMore, { SeeMoreButton } from "components/front/motion/SeeMore";
import useServiceType from "lib/hooks/front/useServiceType";

export type Props = { project: ExhibitionProject; isShopping: boolean };
const DetailQAList: React.FC<Props> = ({ project, isShopping }: Props) => {
  const { isCorpHometownTax } = useServiceType(project.service_type);
  const url = (isCorpHometownTax) ? "https://animefund.zendesk.com/hc/ja/categories/900000172906" : "https://animefund.zendesk.com/hc/ja/categories/900000172886";
  return (
    isShopping ? (
      <>
        {project.content.faq_list.map((faq, index) => (
          <Item key={index}>
            <Row>
              <QuestionMark>Q.</QuestionMark>
              <QuestionText dangerouslySetInnerHTML={{ __html: faq.q.replace(/\n/g, "<br />") }} />
            </Row>
            <Row>
              <AnswerMark>A.</AnswerMark>
              <AnswerText dangerouslySetInnerHTML={{ __html: faq.a.replace(/\n/g, "<br />") }} />
            </Row>
          </Item>
        ))}
        <HelpLinkArea>
          <HelpLink href={url} target="_blank">その他よくある質問はこちら»</HelpLink>
        </HelpLinkArea>
      </>
    ) : (
      <SeeMore threshold={200} noClose color="white" moreText="もっと見る▼" Button={SeeMoreButton}>
        {project.content.faq_list.map((faq, index) => (
          <Item key={index}>
            <Row>
              <QuestionMark>Q.</QuestionMark>
              <QuestionText dangerouslySetInnerHTML={{ __html: faq.q.replace(/\n/g, "<br />") }} />
            </Row>
            <Row>
              <AnswerMark>A.</AnswerMark>
              <AnswerText dangerouslySetInnerHTML={{ __html: faq.a.replace(/\n/g, "<br />") }} />
            </Row>
          </Item>
        ))}
        <HelpLinkArea>
          <HelpLink href={url} target="_blank">その他よくある質問はこちら»</HelpLink>
        </HelpLinkArea>
      </SeeMore>
    )
  );
};
export default DetailQAList;

const HelpLinkArea = styled.div`
  padding: 10px 0;
  text-align: right;
`;
const HelpLink = styled.a`
  text-decoration: underline;
  @media screen and (max-width: 960px) {
    font-size: 12px;
  }
  @media screen and (min-width: 961px) {
    font-size: 14px;
  }
`;
const Item = styled.div`
  padding-bottom: 15px;
  border-bottom: 1px solid #cbcbcb;

  &:not(:first-child) {
    margin-top: 15px;
  }
`;
const Row = styled.div`
  display: flex;
  margin: 6px 0;
  @media screen and (max-width: 960px) {
    &:not(:last-child) {
      margin-bottom: 12px;
    }
  }
`;
const Tag = css`
  margin-right: 12px;
  @media screen and (max-width: 960px) {
    font-size: 22px;
  }
  @media screen and (min-width: 961px) {
    font-size: 24px;
  }
`;
const Text = css`
  width: 100%;
  color: #1a1a1a;
  line-height: 1.357em;
  margin-top: 6px;
`;
const QuestionMark = styled.p`
  ${Tag};
  color: #ff0000;
`;
const QuestionText = styled.p`
  ${Text};
  @media screen and (max-width: 960px) {
    font-size: 14px;
    margin-bottom: 3px;
  }
  @media screen and (min-width: 961px) {
    font-size: 16px;
  }
`;
const AnswerMark = styled.p`
  ${Tag};
  color: #0000ff;
`;
const AnswerText = styled.p`
  ${Text};
  @media screen and (max-width: 960px) {
    font-size: 12px;
  }
  @media screen and (min-width: 961px) {
    font-size: 14px;
  }
`;
